import { createContext } from 'react';

const defaultProject = {};

const ProjectContext = createContext(defaultProject);

export default ProjectContext;
